
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import CsvFormatInfo from './CsvFormatInfo.vue'
import DirectUpload from '@/components/DirectUpload/index.vue'
import { downloadExcelTemplate } from './utils/fileParser'

@Component({
  name: 'FileUploadZone',
  components: {
    CsvFormatInfo,
    DirectUpload
  }
})
export default class FileUploadZone extends Vue {
  @Prop({ required: true }) readonly fileList!: any[]
  @Prop({ required: true }) readonly isParsingCsv!: boolean
  @Prop({ required: true }) readonly isUploading!: boolean

  @Emit('upload')
  handleUpload(file: any) {
    return file
  }

  @Emit('create-new-table')
  createNewTable() {
    return true
  }

  downloadTemplate() {
    const headers = ['firstname', 'lastname', 'email', 'multi_choice_gift_card', 'amount', 'scheduled_at']
    const csvContent = headers.join(';') + '\n'
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)
    link.setAttribute('href', url)
    link.setAttribute('download', 'template.csv')
    link.style.visibility = 'hidden'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  downloadExcelTemplate() {
    downloadExcelTemplate()
  }
}
